import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { BuildDetailsHttpService } from './core/services/build-details.http.service';

import { CurrencyMaskConfig } from 'ng2-currency-mask';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.',
};

export function fetchBuildDetails(buildDetailsService: BuildDetailsHttpService) {
  return () => buildDetailsService.fetchBuildDetails();
}
registerLocaleData(localeIt);
